import * as React from "react";
import { BRAND } from "~/brand";
import { AnwbLogo } from "~/brand/AnwbLogo";
import { cn } from "~/lib/utils";

interface LogoLoaderProps extends React.ComponentProps<"div"> {
  className?: string;
}

export default function LogoLoader({ className, ...props }: LogoLoaderProps) {
  if (BRAND.id === "anwb") {
    return <AnwbLogo className={cn("h-12 w-auto animate-pulse", className)} />;
  }

  return (
    <div className={cn("relative h-[48px] w-[35px]", className)} {...props}>
      {/* Back layer (yellow) */}
      <svg
        width="35"
        height="48"
        viewBox="0 0 35 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0"
        style={{
          animation: "logo-back-slide 2s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite",
        }}
      >
        <path
          d="M34.0801 24.001L19.8848 48H15.165L20.9639 33.8301H12.2061L16.9961 24.001H34.0801ZM18.9141 0L13.1152 14.1699H21.874L17.084 23.999H0L14.1943 0H18.9141Z"
          fill="#F0FA73"
        />
      </svg>
      {/* Front layer (dark) */}
      <svg
        width="35"
        height="48"
        viewBox="0 0 35 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0"
        style={{
          animation:
            "logo-front-slide 2s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite",
        }}
      >
        <path
          d="M34.0801 24.001L19.8848 48H15.165L20.9639 33.8301H12.2061L16.9961 24.001H34.0801ZM18.9141 0L13.1152 14.1699H21.874L17.084 23.999H0L14.1943 0H18.9141Z"
          fill="#292B34"
        />
      </svg>
    </div>
  );
}
